import * as yup from 'yup';
import {
  EmployeesToItemCommissions,
  ItemCategory,
  ItemCommissionType,
  Items,
} from '@prisma/client';

export const itemCommission = yup.object({
  employeeId: yup.string().required('Employee is required'),
  rate: yup
    .number()
    .min(0, 'Rate cannot be less than 0%')
    .max(1, 'Rate cannot be more than 100%')
    .required('Rate is required'),
});

export type ItemCommission = yup.InferType<typeof itemCommission>;

export const itemForm = yup.object({
  itemId: yup.string().nullable().optional(),
  name: yup.string().when('itemId', {
    is: Boolean,
    then: schema => schema.nullable().optional(),
    otherwise: schema => schema.required('Name is required'),
  }),
  category: yup
    .mixed<ItemCategory>()
    .oneOf(Object.values(ItemCategory))
    .when('itemId', {
      is: Boolean,
      then: schema => schema.nullable().optional(),
      otherwise: schema => schema.required('Category is required'),
    }),
  price: yup
    .number()
    .min(0, 'Default price cannot be less than 0.00')
    .when('itemId', {
      is: Boolean,
      then: schema => schema.nullable().optional(),
      otherwise: schema => schema.required('Default price is required'),
    }),
  isTaxable: yup.boolean().when('itemId', {
    is: Boolean,
    then: schema => schema.nullable().optional(),
    otherwise: schema =>
      schema.required('Please select an option for sales tax'),
  }),
  cost: yup
    .number()
    // Transform empty string into `undefined`
    .transform((value, originalValue) =>
      originalValue === '' ? undefined : value,
    )
    .min(0, 'Cost cannot be less than 0')
    .nullable()
    .optional(),
  employeeCommissions: yup.array().of(itemCommission).nullable().optional(),
  commissionType: yup
    .mixed<ItemCommissionType>()
    .oneOf(Object.values(ItemCommissionType), 'Invalid commission type')
    .when('employeeCommisions', {
      is: (employeeCommisions?: ItemCommission[]) =>
        (employeeCommisions?.length ?? 0) > 0 &&
        !!employeeCommisions?.some(c => c.rate > 0),
      then: schema => schema.required('Commission type is required'),
      otherwise: schema => schema.nullable().optional(),
    }),
});

export type ItemForm = yup.InferType<typeof itemForm>;

export interface ItemWithCommissions extends Items {
  employeeCommissions: EmployeesToItemCommissions[];
}

export interface SearchItemsPage {
  result: Items[];
  meta: {
    cursor: string | undefined;
    hasMore: boolean;
  };
}
